/* eslint-disable no-unused-vars */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import InfoIconImg from 'src/assets/benefits-important.svg';
import BenefitsCart, { ReactComponent as BenefitsCartIcon } from 'src/assets/benefits-cart.svg';
import { ReactComponent as BenefitsAvailableIcon } from 'src/assets/benefits-available.svg';

import { AlertAdapter, FullScreenLoading, RegularButton } from 'pg-ui-library';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { useQuery } from '@tanstack/react-query';

import BenefitsService from 'src/services/benefits.service';

import { useActions } from 'src/hooks/useActions';
import { monetaryUSDFormat } from 'src/utils/currencyFormat';

import { IBenefit, ICartBenefit } from 'src/interfaces';
import AddressForm from 'src/modules/personal-info/components/address-form';
import { PersonalInfoForm } from 'src/modules/personal-info';
import {
  Container,
  Header,
  HeaderTitle,
  Content,
  HeaderItemLeft,
  HeaderItemRight,
  CancelButton,
  InfoIconContainer,
  InfoIcon,
  TooltipText,
  RelativeContainer,
  ScrollableContainer,
  ScrollableContainerEmpty,
  CartFooter,
  CartFooterText,
  CartContainer,
  LeftGridContent,
  RightGridContent,
} from './styles';

import EnrollmentChanges from '../enrollment-changes';
import CartTabs from '../cart-tabs';

import { EnrollSelectionModal } from '../enroll-selection-modal';
import { StoreContextProvider, useBenefitEnrollSelectionModalIsOpen } from '../../enrollment.context';
import { BenefitEventType, benefitsCategories } from '../..';
import BenefitCard from '../benefit-card';

import AvailableBenefitsCard from '../available-benefits-card';
import { EnrollmentSteps, EnrollmentWizard } from '../enrollment-wizard';
import AddressTable from '../address-table';
import ContactsTable from '../contacts-table';

const HealthWrapper: React.FC = () => (
  <>
    <EnrollmentChanges categories={[benefitsCategories[0]]} enabledHeader={false} eventType="open_enrollment" />
  </>
);
const IncomeSecurityWrapper: React.FC = () => (
  <>
    <EnrollmentChanges categories={[benefitsCategories[1]]} enabledHeader={false} eventType="open_enrollment" />
  </>
);
const RetirmentLifestyleWrapper: React.FC = () => (
  <>
    <EnrollmentChanges categories={[benefitsCategories[2]]} enabledHeader={false} eventType="open_enrollment" />
  </>
);

const OpenEnrollment: React.FC = () => {
  const { loading } = useTypedSelector(state => state.benefits);
  const { cart, fetchingCartSession, benefits, freePlansAvailable } = useTypedSelector(state => state.benefits.data);
  const isOpen = useBenefitEnrollSelectionModalIsOpen();
  const steps: EnrollmentSteps[] = [
    {
      title: 'Step 1:',
      subtitle: 'Address',
      content: <AddressTable />,
      available: true, // Always available
    },
    {
      title: 'Step 2:',
      subtitle: 'Contacts Information',
      content: <ContactsTable />,
      available: true, // Always available
    },
    {
      title: 'Step 3:',
      subtitle: 'Health & Well-Being',
      content: <HealthWrapper />,
      available: true,
    },
    {
      title: 'Step 4:',
      subtitle: 'Income Security',
      content: <IncomeSecurityWrapper />,
      available: true,
    },
    {
      title: 'Step 5:',
      subtitle: 'Retirement & Lifestyle',
      content: <RetirmentLifestyleWrapper />,
      available: true,
    },
  ];

  const { t } = useTranslation();
  const { getPersonalInfo, getCartSession, setBenefitEnrollmentType } = useActions();
  const [mandatoryBenefits] = useState<IBenefit[]>();
  const { addBenefitToCart } = useActions();
  const { data: freePlans, isLoading: loadingFreePlans } = useQuery({
    queryKey: ['benefits/free-plans'],
    queryFn: () => BenefitsService.getFreePlans(BenefitEventType.OPEN_ENROLLMENT),
    enabled: true,
  });

  const isEmpty = cart ? cart?.length <= 0 : true;

  const totalAddedToCart = cart
    ?.filter(benefit => benefit.action === 'ADD')
    ?.map(benefit => benefit.price)
    .reduce((acc, next) => Number(acc) + Number(next), 0) as unknown as 0;

  const navigate = useNavigate();

  useEffect(() => {
    setBenefitEnrollmentType('open_enrollment');
    getPersonalInfo();
    getCartSession(BenefitEventType.OPEN_ENROLLMENT);
  }, []);

  useEffect(() => {
    if (!fetchingCartSession) {
      if (freePlansAvailable && freePlans && freePlans.length > 0) {
        freePlans.forEach((freePlan: IBenefit) => {
          const freeBenefit: ICartBenefit = {
            type: freePlan.type || '',
            benefitId: freePlan.benefitId,
            generalCategory: freePlan.generalCategory,
            imgURL: freePlan.imgURL,
            planDescription: freePlan.type || '',
            optionDescription: freePlan.optionDescription,
            price: 0,
            expiration: freePlan.expiration,
            action: 'ADD',
            benefitName: freePlan.type || '',
            benefitPlanId: freePlan.benefitPlanId,
            benefitOptionId: freePlan.benefitOptionId,
            benefitEnrollmentStart: freePlan.benefitEnrollmentStart,
            benefitEnrollmentEnd: freePlan.benefitEnrollmentEnd,
            benefitProvider: freePlan.benefitProvider,
            employeeName: freePlan.employeeName,
            employeeCost: 0,
            employerName: freePlan.employerName,
            employerCost: 0,
            percent: 0,
            fixedAmount: 0,
            dependents: '',
            employeeChoosesPayment: null,
            costCalculationMethod: freePlan.costCalculationMethod,
          };
          addBenefitToCart({ ...freeBenefit });
        });
      }
    }
  }, [freePlans, fetchingCartSession]);

  const startReview = () => {
    const stateData = { event: 'open_enrollment' };

    navigate('/benefits/review', { state: stateData });
  };
  const removedBenefits = cart?.filter(benefit => benefit.action === 'REMOVE').map(benefit => benefit.benefitId);

  const benefitsNotRemoved = benefits
    .filter(benefit => !removedBenefits?.includes(benefit.benefitId))
    .filter(b => b.costCalculationMethod !== 'Free');

  return (
    <Container>
      {(loading || fetchingCartSession || loadingFreePlans) && <FullScreenLoading />}
      <Header>
        <HeaderItemLeft>
          <HeaderTitle>{t('benefits.openEnrollment.title')}</HeaderTitle>
          <InfoIconContainer>
            <RelativeContainer id="tooltip">
              <TooltipText>{t('benefits.openEnrollment.balloon')}</TooltipText>
            </RelativeContainer>
            <InfoIcon src={InfoIconImg} />
          </InfoIconContainer>
        </HeaderItemLeft>
        <HeaderItemRight>
          <CancelButton onClick={() => navigate('/benefits', { replace: true })}>
            {t('global.form.cancel')}
          </CancelButton>
        </HeaderItemRight>
      </Header>
      <Content>
        <LeftGridContent>
          <EnrollmentWizard steps={steps} submit={startReview} />
          {isOpen && <EnrollSelectionModal eventType={BenefitEventType.OPEN_ENROLLMENT} />}
        </LeftGridContent>
        <RightGridContent>
          <CartTabs
            firstTabTitle="Active"
            FirstTabIcon={BenefitsAvailableIcon}
            secondTabTitle="Cart"
            SecondTabIcon={BenefitsCartIcon}
            FirstTabContent={() => (
              <ScrollableContainer>
                {benefitsNotRemoved.map((benefit, index) => (
                  <BenefitCard
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    benefitId={benefit.benefitId}
                    imgURL={benefit.imgURL}
                    title={benefit.benefitName}
                    subtitle={benefit.benefitOptionId}
                    fee={benefit.basis?.toLowerCase() === 'fixed amount' ? monetaryUSDFormat(benefit.employeeCost) : ''}
                    date={benefit.benefitEnrollmentEnd}
                    handleDelete={() => {
                      addBenefitToCart({
                        ...benefit,
                        price: benefit.employeeCost,
                        action: 'REMOVE',
                      });
                      AlertAdapter('Benefit marked to be removed and added to cart', 'success');
                    }}
                  />
                ))}
              </ScrollableContainer>
            )}
            SecondTabContent={() => (
              <>
                {isEmpty && mandatoryBenefits?.length === 0 ? (
                  <ScrollableContainerEmpty>
                    <img src={BenefitsCart} />
                    <h3 style={{ margin: 0 }}>{t('benefits.newHire.emptyCart.line1')}</h3>
                    <p style={{ margin: 0 }}>{t('benefits.newHire.emptyCart.line2')}</p>
                    <p style={{ margin: 0 }}>{t('benefits.newHire.emptyCart.line3')}</p>
                  </ScrollableContainerEmpty>
                ) : (
                  <CartContainer>
                    <ScrollableContainer>
                      {cart?.map((benefit, index) => (
                        <AvailableBenefitsCard
                          // eslint-disable-next-line react/no-array-index-key
                          key={index}
                          type={benefit.type}
                          benefitId={benefit.benefitId}
                          imgURL={benefit.imgURL}
                          title={benefit.planDescription || benefit.benefitName}
                          subtitle={
                            benefit.dependentsDescription ? benefit.dependentsDescription : benefit.optionDescription
                          }
                          fee={monetaryUSDFormat(benefit.price)}
                          date={benefit.expiration}
                          editMode={benefit.costCalculationMethod?.toLowerCase() !== 'free'}
                          deleteMode={benefit.costCalculationMethod?.toLowerCase() !== 'free'}
                          mandatory={false}
                        />
                      ))}
                    </ScrollableContainer>
                    <CartFooter>
                      {/* <RegularButton onClick={startReview}>{t('global.form.continue')}</RegularButton> */}
                      <CartFooterText>
                        {t('benefits.newHire.totalOnCart')}: {monetaryUSDFormat(totalAddedToCart ?? 0)}
                      </CartFooterText>
                    </CartFooter>
                  </CartContainer>
                )}
              </>
            )}
          />
        </RightGridContent>
      </Content>
    </Container>
  );
};

const OpenEnrollmentStoreWrapper: React.FC = () => (
  <StoreContextProvider>
    <OpenEnrollment />
  </StoreContextProvider>
);
export default OpenEnrollmentStoreWrapper;
